import { StringHash } from '@app/shared/utils/utils-types';
import { TopicField } from '@app/origami-api/utils/topic-utils';
import { BaseSettingsGroup, createSettingsDecorator } from './setting-group-base';
import { SettingValue } from './setting-value';
import { Observable, of } from 'rxjs';

export class SettingsSubModule extends BaseSettingsGroup<StringHash<TopicField>, TopicField[]> {
  static value(dbName: string, defaultValue: any, options?: SettingValueOptions<any>) {
    return createSettingsDecorator(function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this: SettingsSubModule = this;

      return new SettingValue<any>(
        dbName,
        defaultValue,
        _this.mainStore,
        _this.defaultStore,
        (field) => _this.saveData([field]),
        options ? options.setterConverter : null,
        options ? options.getterConverter : null,
      );
    });
  }

  save(): Observable<boolean> {
    const fields = this.getDbValues();
    return fields.length ? this.saveData(fields) : of(false);
  }

  getValues(): StringHash<any> {
    const result = {};
    this.keys.forEach((key) => (result[this[key].dbName] = this[key].get()));
    return result;
  }

  getDbValues(returnOnlyDirty: boolean = true): TopicField[] {
    return this.keys.map((key) => this[key].getDbValue(returnOnlyDirty)).filter((v) => v);
  }
}

interface SettingValueOptions<T> {
  setterConverter?: (value: T) => string;
  getterConverter?: (value: string) => T;
}
